import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NewsFeedItemHeaderBase } from '../news-feed-item-header-base';

@Component({
    selector: 'fi-news-feed-item-header-media-bank',
    templateUrl: './news-feed-item-header-media-bank.component.html',
    styleUrls: ['./news-feed-item-header-media-bank.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NewsFeedItemHeaderMediaBankComponent extends NewsFeedItemHeaderBase {}
